import { useState, useEffect } from "react";
import api from "../../api/client";

export default function NapHistoryModal({ record, onClose }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const { data } = await api.get(`/nap-locator/${record.id}/history`);
        setHistory(data);
      } catch (err) {
        console.error("Failed to fetch history", err);
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, [record.id]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    return d.toLocaleString("en-PH", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg mx-4 p-6 max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-lg font-semibold">Update History</h2>
            <p className="text-sm text-gray-500">{record.nap_code}</p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl leading-none"
          >
            ×
          </button>
        </div>

        <div className="flex-1 overflow-auto min-h-0">
          {loading ? (
            <p className="text-center text-gray-400 py-8">Loading...</p>
          ) : history.length === 0 ? (
            <p className="text-center text-gray-400 py-8">No history records found.</p>
          ) : (
            <table className="w-full text-sm">
              <thead className="bg-gray-50 sticky top-0">
                <tr className="text-left text-gray-600">
                  <th className="px-3 py-2 font-semibold">Date Updated</th>
                  <th className="px-3 py-2 font-semibold">Updated By</th>
                  <th className="px-3 py-2 font-semibold">Update Done</th>
                </tr>
              </thead>
              <tbody>
                {history.map((h) => (
                  <tr key={h.id} className="border-t border-gray-100">
                    <td className="px-3 py-2 text-gray-600 whitespace-nowrap">{formatDate(h.performed_at)}</td>
                    <td className="px-3 py-2 font-medium">{h.performed_by_name ?? "—"}</td>
                    <td className="px-3 py-2">
                      <span className="font-medium text-gray-800">{h.action}</span>
                      {h.details && (
                        <p className="text-xs text-gray-500 mt-0.5">{h.details}</p>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="flex-shrink-0 flex justify-end mt-4 pt-3 border-t">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm border rounded hover:bg-gray-100"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
